module.exports = __webpack_public_path__ + "static/media/de-DE.c293b4e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard-languages/de-DE.png
// module id = 938
// module chunks = 0